'use strict';

function uploader($window, attachmentService) {
  return {
    restrict: 'E',
    replace: true,
    template: `<fieldset>
      <p>For eksempel tegninger eller detaljert prosjektplan. Lastes opp i PDF format.</p>
      <form name="uploader" ng-submit="upload($event)" ng-cloak novalidate>
        <h3 class="subheader">Last opp et vedlegg</h3>
        <alert data="alert" />
        <input type="file" name="uploaded_file">
        <div class="loader" ng-show="disabled"></div>
        <button type="submit" class="button" ng-disabled="disabled">Last opp</button>
      </form>
      <table ng-show="attachments.length">
        <tr ng-repeat="file in attachments track by file.number">
          <td>{{ $index + 1 }}</td>
          <td>{{ file.name }}</td>
          <td class="right-align"><a href ng-click="remove(file.number)"><i class="fa fa-trash"></i></a></td>
        </tr>
      </table>
    </fieldset>`,
    link: (scope, el) => {
      scope.alert = {};
      scope.attachments = [];

      const MAX_FILE_SIZE = 5242880;
      const MAX_FILENAME = 255;
      const FILE_ALLOWED = 'pdf';

      scope.upload = (e) => {
        e.preventDefault();

        if (e && e.target && e.target.length) {
          let filename = e.target[0].value.replace('C:\\fakepath\\', '');
          let filesize = e.target[0].files.length && e.target[0].files[0].size;

          if (filesize > MAX_FILE_SIZE) {
            scope.alert = {
              type: 'error',
              message: 'Vedlegget kan ikke være større enn 5 MB'
            };
          } else if (filename.length > MAX_FILENAME) {
            scope.alert = {
              type: 'error',
              message: `Filnavn kan ikke være lenger enn ${MAX_FILENAME} bokstaver`
            };
          } else if (filename.split('.').pop().toLowerCase() !== FILE_ALLOWED) {
            scope.alert = {
              type: 'error',
              message: `Vedlegget kan bare være en ${FILE_ALLOWED}-fil`
            };
          } else if (filename.match(/\\/g)) {
            scope.alert = {
              type: 'error',
              message: 'Filnavnet kan ikke innholder \\ eller /'
            };
          } else {
            scope.disabled = true;

            let headers = {
              'End-User-Message': true,
              'API-Version': '1.0',
              Client: 'browser'
            };

            const originatorId = $window.sessionStorage.getItem('originatorId');
            if (originatorId) {
              headers['Originator-Id'] = originatorId;
            }

            const req = $.ajax({
              url: '/attachment/upload',
              type: 'POST',
              data: new FormData(el.find('form')[0]),
              processData: false,
              contentType: false,
              headers: headers
            });

            req.done((data) => {
              scope.$apply(() => {
                scope.attachments.push({
                  number: data.number,
                  name: filename
                });

                scope.disabled = false;
              });
            });

            req.fail((err) => {
              scope.$apply(() => {
                scope.alert = {
                  type: 'error',
                  message: err.endUserMessage
                };

                scope.disabled = false;
              });
            });

            el.find('form')[0].reset();
          }
        }
      };

      scope.remove = (number) => {
        attachmentService.delete(number)
          .then(() => {
            $.grep(scope.attachments, (i, idx) => {
              if (i && i.number === number) {
                scope.attachments.splice(idx, 1);
              }
            });
          });
      };

      scope.$watchCollection('attachments', (val) => {
        scope.alert = {};
        let counts = [];

        for (let i = 0; i <= val.length; i++) {
          if (val[i] && val[i].name) {
            if (typeof counts[val[i].name] === 'undefined') {
              counts[val[i].name] = 1;
            } else {
              scope.alert = {
                type: 'warning',
                message: `Du har allerede lastet opp et vedlegg med filnavn: ${val[i].name}`
              };
            }
          }
        }

        scope.$emit('attachments', val);
        scope.$broadcast('attachments', val);
      });

      scope.$watch('disabled', (val) => {
        scope.$emit('loadingAttachment', val);
        scope.$broadcast('loadingAttachment', val);
      });
    }
  };
}

uploader.$inject = ['$window', 'attachmentService'];

angular
  .module('SendRegning')
  .directive('uploader', uploader);
